// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/stepup/v1/stepup.proto" (package "c1.api.stepup.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { StepUpTransactionService } from "./stepup";
import type { SearchStepUpTransactionsResponse } from "./stepup";
import type { SearchStepUpTransactionsRequest } from "./stepup";
import type { GetStepUpTransactionResponse } from "./stepup";
import type { GetStepUpTransactionRequest } from "./stepup";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { StepUpProviderService } from "./stepup";
import type { TestStepUpProviderResponse } from "./stepup";
import type { TestStepUpProviderRequest } from "./stepup";
import type { DeleteStepUpProviderResponse } from "./stepup";
import type { DeleteStepUpProviderRequest } from "./stepup";
import type { UpdateStepUpProviderSecretResponse } from "./stepup";
import type { UpdateStepUpProviderSecretRequest } from "./stepup";
import type { UpdateStepUpProviderResponse } from "./stepup";
import type { UpdateStepUpProviderRequest } from "./stepup";
import type { CreateStepUpProviderResponse } from "./stepup";
import type { CreateStepUpProviderRequest } from "./stepup";
import type { SearchStepUpProvidersResponse } from "./stepup";
import type { SearchStepUpProvidersRequest } from "./stepup";
import type { GetStepUpProviderResponse } from "./stepup";
import type { GetStepUpProviderRequest } from "./stepup";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ListStepUpProvidersResponse } from "./stepup";
import type { ListStepUpProvidersRequest } from "./stepup";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.stepup.v1.StepUpProviderService
 */
export interface IStepUpProviderServiceClient {
    /**
     * @generated from protobuf rpc: List
     */
    list(input: ListStepUpProvidersRequest, options?: RpcOptions): UnaryCall<ListStepUpProvidersRequest, ListStepUpProvidersResponse>;
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: GetStepUpProviderRequest, options?: RpcOptions): UnaryCall<GetStepUpProviderRequest, GetStepUpProviderResponse>;
    /**
     * Search allows searching for step-up providers with various filters
     *
     * @generated from protobuf rpc: Search
     */
    search(input: SearchStepUpProvidersRequest, options?: RpcOptions): UnaryCall<SearchStepUpProvidersRequest, SearchStepUpProvidersResponse>;
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: CreateStepUpProviderRequest, options?: RpcOptions): UnaryCall<CreateStepUpProviderRequest, CreateStepUpProviderResponse>;
    /**
     * @generated from protobuf rpc: Update
     */
    update(input: UpdateStepUpProviderRequest, options?: RpcOptions): UnaryCall<UpdateStepUpProviderRequest, UpdateStepUpProviderResponse>;
    /**
     * @generated from protobuf rpc: UpdateSecret
     */
    updateSecret(input: UpdateStepUpProviderSecretRequest, options?: RpcOptions): UnaryCall<UpdateStepUpProviderSecretRequest, UpdateStepUpProviderSecretResponse>;
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: DeleteStepUpProviderRequest, options?: RpcOptions): UnaryCall<DeleteStepUpProviderRequest, DeleteStepUpProviderResponse>;
    /**
     * @generated from protobuf rpc: Test
     */
    test(input: TestStepUpProviderRequest, options?: RpcOptions): UnaryCall<TestStepUpProviderRequest, TestStepUpProviderResponse>;
}
/**
 * @generated from protobuf service c1.api.stepup.v1.StepUpProviderService
 */
export class StepUpProviderServiceClient implements IStepUpProviderServiceClient, ServiceInfo {
    typeName = StepUpProviderService.typeName;
    methods = StepUpProviderService.methods;
    options = StepUpProviderService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: List
     */
    list(input: ListStepUpProvidersRequest, options?: RpcOptions): UnaryCall<ListStepUpProvidersRequest, ListStepUpProvidersResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListStepUpProvidersRequest, ListStepUpProvidersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: GetStepUpProviderRequest, options?: RpcOptions): UnaryCall<GetStepUpProviderRequest, GetStepUpProviderResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetStepUpProviderRequest, GetStepUpProviderResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Search allows searching for step-up providers with various filters
     *
     * @generated from protobuf rpc: Search
     */
    search(input: SearchStepUpProvidersRequest, options?: RpcOptions): UnaryCall<SearchStepUpProvidersRequest, SearchStepUpProvidersResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchStepUpProvidersRequest, SearchStepUpProvidersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: CreateStepUpProviderRequest, options?: RpcOptions): UnaryCall<CreateStepUpProviderRequest, CreateStepUpProviderResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateStepUpProviderRequest, CreateStepUpProviderResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Update
     */
    update(input: UpdateStepUpProviderRequest, options?: RpcOptions): UnaryCall<UpdateStepUpProviderRequest, UpdateStepUpProviderResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateStepUpProviderRequest, UpdateStepUpProviderResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSecret
     */
    updateSecret(input: UpdateStepUpProviderSecretRequest, options?: RpcOptions): UnaryCall<UpdateStepUpProviderSecretRequest, UpdateStepUpProviderSecretResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateStepUpProviderSecretRequest, UpdateStepUpProviderSecretResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: DeleteStepUpProviderRequest, options?: RpcOptions): UnaryCall<DeleteStepUpProviderRequest, DeleteStepUpProviderResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteStepUpProviderRequest, DeleteStepUpProviderResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Test
     */
    test(input: TestStepUpProviderRequest, options?: RpcOptions): UnaryCall<TestStepUpProviderRequest, TestStepUpProviderResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<TestStepUpProviderRequest, TestStepUpProviderResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * StepUpTransactionService provides endpoints for retrieving and searching step-up authentication transactions
 *
 * @generated from protobuf service c1.api.stepup.v1.StepUpTransactionService
 */
export interface IStepUpTransactionServiceClient {
    /**
     * Get retrieves a specific step-up transaction by ID
     *
     * @generated from protobuf rpc: Get
     */
    get(input: GetStepUpTransactionRequest, options?: RpcOptions): UnaryCall<GetStepUpTransactionRequest, GetStepUpTransactionResponse>;
    /**
     * Search allows searching for step-up transactions with various filters
     *
     * @generated from protobuf rpc: Search
     */
    search(input: SearchStepUpTransactionsRequest, options?: RpcOptions): UnaryCall<SearchStepUpTransactionsRequest, SearchStepUpTransactionsResponse>;
}
/**
 * StepUpTransactionService provides endpoints for retrieving and searching step-up authentication transactions
 *
 * @generated from protobuf service c1.api.stepup.v1.StepUpTransactionService
 */
export class StepUpTransactionServiceClient implements IStepUpTransactionServiceClient, ServiceInfo {
    typeName = StepUpTransactionService.typeName;
    methods = StepUpTransactionService.methods;
    options = StepUpTransactionService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Get retrieves a specific step-up transaction by ID
     *
     * @generated from protobuf rpc: Get
     */
    get(input: GetStepUpTransactionRequest, options?: RpcOptions): UnaryCall<GetStepUpTransactionRequest, GetStepUpTransactionResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetStepUpTransactionRequest, GetStepUpTransactionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Search allows searching for step-up transactions with various filters
     *
     * @generated from protobuf rpc: Search
     */
    search(input: SearchStepUpTransactionsRequest, options?: RpcOptions): UnaryCall<SearchStepUpTransactionsRequest, SearchStepUpTransactionsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchStepUpTransactionsRequest, SearchStepUpTransactionsResponse>("unary", this._transport, method, opt, input);
    }
}
